const palisade = {
    timeout: 8000,
    notifications: [],
    add(notification) {
        notification.id = Math.random().toString(36).substring(2);
        notification.progress = 100;
        notification.progressBar = notification.progressBar ?? true;
        notification.close = notification.close ?? true;
        notification.icon = notification.icon ?? true;
        notification.type = notification.type ?? null;
        notification.timeout = this.timeout;
        notification.progressInterval = null;

        this.notifications.push(notification);
        this.play(notification.id);
    },
    play(id) {
        let notification = this.notifications.find((notification) => notification.id === id);
        if (notification.progressBar) {
            let intervalSpeed = 100;
            let incrementSpeed = 1;
            let parent = this;
            notification.progressInterval = setInterval(function () {
                notification.progress -= incrementSpeed;
                if (notification.progress <= 0) {
                    parent.remove(id);
                    clearInterval(notification.progressInterval);
                }
            }, intervalSpeed);
        } else {
            setTimeout(() => {
                this.remove(id);
            }, notification.timeout);
        }
    },
    remove(id) {
        const notification = this.notifications.find((notification) => notification.id === id);

        if (!notification) {
            return;
        }

        notification.timeout = this.timeout;
        clearInterval(notification.progressInterval)

        const index = this.notifications.indexOf(notification);
        this.notifications.splice(index, 1);
    },
    init(notification) {
        if (notification) {
            this.add(notification);
        }
    }
};

const newUi = {
    timeout: 10000,
    notifications: [],
    add(notification = {}) {
        notification.id = Math.random().toString(36).substring(2);
        notification.close = notification.close ?? true;
        notification.icon = notification.icon ?? true;
        notification.type = notification.type ?? 'success';
        notification.title = notification.title ?? null;
        notification.expanded = window.innerWidth >= 768;
        notification.isTextTruncated = false;
        notification.timeout = this.timeout;
        notification.progressBar = notification.progressBar ?? true;
        notification.progressInterval = null;
        notification.progress = 100;

        this.notifications.push(notification);

        this.play(notification.id);
    },
    play(id) {
        let notification = this.notifications.find((notification) => notification.id === id);
        if(notification.progressBar) {
            let intervalSpeed = 100;
            let incrementSpeed = 1;
            let parent = this;
            notification.progressInterval = setInterval(function() {
                notification.progress -= incrementSpeed;
                if(notification.progress <= 0) {
                    parent.remove(id);
                    clearInterval(notification.progressInterval);
                }
            }, intervalSpeed);
        } else {
            setTimeout(() => {
                this.remove(id);
            }, notification.timeout);
        }
    },
    remove(id) {
        const notification = this.notifications.find((notification) => notification.id === id);

        if(!notification) {
            return;
        }

        notification.timeout = this.timeout;
        clearInterval(notification.progressInterval);

        const index = this.notifications.indexOf(notification);
        this.notifications.splice(index, 1);
    },
    calculateIsTextTruncated(notification) {
        notification.isTextTruncated = this.$refs.textElement.scrollHeight > this.$refs.wrapperElement.clientHeight;
    },
    handleScrollPosition() {
        const scroll = document.documentElement.scrollTop;

        if(scroll > 0) {
            this.$refs.notificationsContainer.classList.add('fixed');
            this.$refs.notificationsContainer.classList.remove('relative');
        } else {
            this.$refs.notificationsContainer.classList.add('relative');
            this.$refs.notificationsContainer.classList.remove('fixed');
        }
    },
    init(notification) {
        if (notification) {
            this.add(notification);
        }
    }
};

const notifications = (usePalisadeNotify = true) => usePalisadeNotify ? palisade : newUi;

export default notifications;
